
import styles from "./footer.module.css";
const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>Нейросеть</p>

      <div className={styles.footerscroll}>
        <div className={styles.scrollfot}>
          <div className={styles.mains}>
            <a href="#" className={styles.logofooter}>I’m-GPT</a>
            <p>
              Чат GPT - это чат, в котором используется технология искусственного интеллекта GPT (Generative Pre-trained Transformer), позволяющая создавать искусственный разговор с пользователем.
            </p>
            <img src='img/vis.png' alt="Visual" />
          </div>

          <div className={styles.texta}>
            <h4>Компания</h4>
            <p>Все права защищены © 2026</p>
            <p>ИП Попов В.Е.</p>
            <p>ИНН: 346100913190</p>
            <p>ОГРНИП: 322344300006615</p>
            <p>г. Волгоград, Улица Кирова 121А</p>
          </div>

          <div className={styles.texta}>
            <h4>Документы</h4>
            <a href="docs/public_offer.pdf" target="_blank" rel="noopener noreferrer">Публичная оферта</a>
            <a href="docs/processing.pdf" target="_blank" rel="noopener noreferrer">Согласие на обработку данных</a>
          
          </div>

          <div className={styles.textb}>
            <h4>Клиент-центр</h4>
            <a href="mailto:im-gpt.ru@yandex.ru" target="_blank" rel="noopener noreferrer">Связь с нами</a>
            <a href="mailto:im-gpt.ru@yandex.ru" target="_blank" rel="noopener noreferrer">Служба поддержки</a>
            <a href="mailto:im-gpt.ru@yandex.ru" target="_blank" rel="noopener noreferrer">E-mail: im-gpt.ru@yandex.ru</a>
            <a href="/chat?login">Личный кабинет</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
